import { Avatar, Stack, Typography } from '@mui/material'
import { IconButton, Icons } from 'utoniq-ui'

import { ThroughTicketTag } from '@/components/organisms'
import { config } from '@/config'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import type { State } from '../../viewModel'

type ItemDescriptionCellProps = {
  portfolio: State['portfolio']
}
/**
 * OwnedItemDetail
 * サムネイル下のアイテム情報を表示している部分
 */
export const ItemDescriptionCell: Cell<ItemDescriptionCellProps> = ({
  portfolio,
}) => {
  const { t } = useTranslation('ownedItemDetail')
  const { generatePath, routerPages } = useRouter()
  const { number: possessionNumber } = portfolio || {}
  const { rarity, title, sku } = portfolio?.item || {}
  const issuableNft = !!portfolio?.item.nft?.chains
  const isUserProtected = !!portfolio?.isUserProtected
  const isThroughTicket = portfolio?.item?.metadata?.ticket?.isThroughTicket

  return (
    <CellFrame
      sx={{ display: 'grid', gridTemplateColumns: '1fr', py: 3, gap: 2 }}
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <Stack direction="row" alignItems="center">
          {config.modules.nft && issuableNft && (
            <IconButton.Nft
              href={generatePath(routerPages.OwnedItemNftItems, {
                itemId: portfolio?.item?.id || '#',
              })}
              sx={{
                fontSize: 'medium',
              }}
            />
          )}
          {isUserProtected && <Icons.UniqueProtect fontSize="medium" />}
        </Stack>
        <Stack alignItems="center">
          <Typography variant="h5" textAlign="center">
            {title}
          </Typography>
          <Stack direction="row" alignItems="center">
            {sku && (
              <Typography sx={{ mt: 1 }} variant="body2" textAlign="center">
                {sku.unitName}
              </Typography>
            )}
            {isThroughTicket && <ThroughTicketTag />}
          </Stack>
        </Stack>
      </Stack>

      <Stack direction="row" justifyContent="center" spacing={4}>
        {rarity?.name && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="overline" color="text.hint" sx={{ py: 2 }}>
              {t('rarity')}
            </Typography>
            {portfolio?.item.rarityIconImage?.smallUri && (
              <Avatar
                variant="square"
                src={portfolio?.item.rarityIconImage.smallUri}
                sx={{
                  height: 12,
                  width: 12,
                }}
              />
            )}
            <Typography variant="overline">
              {rarity?.name ? t(rarity.name) : '-'}
            </Typography>
          </Stack>
        )}
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="overline" color="text.hint" sx={{ py: 2 }}>
            {t('possessionNumber')}
          </Typography>
          <Typography variant="overline">{possessionNumber}</Typography>
        </Stack>
      </Stack>
    </CellFrame>
  )
}
